import { policiesService } from '@/services/policies';
import type { GetPoliciesParams } from '@/services/policies/types';
import { useQuery } from '@tanstack/react-query';

interface UsePoliciesOptions extends GetPoliciesParams {
  enabled?: boolean;
}

export function usePolicies(options: UsePoliciesOptions = {}) {
  const { enabled = true, ...params } = options;

  return useQuery({
    queryKey: ['policies', params],
    queryFn: async () => {
      const response = await policiesService.getPolicies(params);

      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao carregar apólices');
      }

      return response.data;
    },
    staleTime: 1000 * 60 * 5,
    enabled,
  });
}
